"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWrapButtonsArrows = exports.StyledWrapButtonIcon = exports.StyledHeaderLists = exports.StyledCustomHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCustomHeader = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;

  button {
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.text.primary};
    cursor: pointer;
    font-size: 14px;
    &[data-islistopen="true"] {
      color: ${({ theme }) => theme.primary.main};
    }

    &:focus-visible {
      outline-color: ${({ theme }) => theme.neutral.light};
    }
  }
`;
exports.StyledHeaderLists = styled_components_1.default.div `
  align-items: center;
  background: white;
  border-top: 1px solid ${({ theme }) => theme.neutral.light};
  color: ${({ theme }) => theme.text.primary};
  display: grid;
  grid-template-columns: repeat(4, 50px);
  grid-template-rows: repeat(3, 1fr);
  height: calc(100% - 45px);
  justify-content: space-between;
  left: 0;
  overflow: auto;
  padding: 10px;
  position: absolute;
  top: 45px;
  width: 100%;

  & > div {
    display: grid;
    color: ${({ theme }) => theme.text.primary};
    cursor: pointer;
    height: 50px;
    transition: all 0.4s ease;
    place-items: center;

    &[data-selected="true"],
    &:hover {
      border-radius: 100px;
    }

    &[data-selected="true"] {
      background: ${({ theme }) => theme.primary.main}
      color: ${({ theme }) => theme.white};
      font-weight: 500;
    }

    &:hover {
      background: ${({ theme }) => theme.primary.light};
    }
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.white};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.neutral.light};
    border-radius: 20px;
  }
`;
exports.StyledWrapButtonIcon = styled_components_1.default.button `
  transition: transform 0.4s ease;

  &[data-rotate="true"] {
    transform: rotate(180deg);
  }
`;
exports.StyledWrapButtonsArrows = styled_components_1.default.div `
  & > button {
    margin-left: 5px;
  }
`;
